import * as React from "react";
import * as $ from "jquery";
import * as Highcharts from "highcharts";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { groupProductDetail } from "../../Common/PortfolioDashboardHelper";
import { PortfolioDashboardMultiSelectionStore, PortfolioDashboardStore } from "../../../Store/Variable";
import {
    ProductValuationDetailSummary
} from "../../../../../../../../Wrap/Models/Domains/Valuation/ProductValuationDetailSummary";
import { ObjectComparer } from "../../../../../../../../react-core/Utils/ObjectComparer"
import { WrapperSubType } from "../../../../../../../../Wrap/Constants/Enums/Domain/WrapperSubType";


interface ICircleChartProps {
    chartData?: ProductValuationDetailSummary[];
    chartId?: string;
    chartType?: string;
}

interface ICircleChartState {
    chart?: Highcharts.Chart;
}
export class CircleChart extends React.Component<ICircleChartProps, ICircleChartState> {
    constructor(props: any) {
        super(props);
    }

    private settings = {};

    public componentDidMount() {
        const { chartData } = this.props;

        if (chartData && chartData.length > 0) {
            setTimeout(() => {
                this.initChart(this.props.chartId, this.props.chartType, this.props.chartData);
            }, 100);
        }
    }

    public componentDidUpdate(prevProps: Readonly<ICircleChartProps>): void {
        if (!ObjectComparer.isSame(prevProps, this.props)) {
            this.state.chart.update({ series: [this.getSeriesData(this.props.chartData)] });
        }
    }

    public render(): JSX.Element {
        return (
            <div
                className="valuation-summary-chart"
                id={this.props.chartId}
                data-chartdata={this.props.chartData}
            ></div>
        );
    }

    private initChart(chartId: string, chartType: string, chartData: Array<ProductValuationDetailSummary>): any {
        const newChart = Highcharts.chart(chartId, {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: chartType,
                width: 220,
                height: 220,
                margin: [0, 0, 0, 0],
                backgroundColor: "rgba(255,255,255,0)",
                plotBorderColor: null,
                plotBackgroundImage: null,
            },
            legend: {
                backgroundColor: "white",
            },
            title: { text: "" },
            subtitle: { text: "" },
            credits: {
                enabled: false,
            },
            tooltip: {
                enabled: true,
                formatter: function () {
                    return (
                        "<span style='color:" +
                        this.point.color +
                        "'>" +
                        this.point.name +
                        "</span>" +
                        "<br />" +
                        this.point.x +
                        "<br />" +
                        "<span style='font-weight: bold'>" +
                        Highcharts.numberFormat(this.point.percentage, 2, ".") +
                        "%" +
                        "</span>"
                    );
                },
            },
            plotOptions: {
                pie: {
                    allowPointSelect: false,
                    cursor: "pointer",
                    dataLabels: {
                        enabled: false,
                    },
                    borderWidth: 1,
                    innerSize: "92%",
                    showInLegend: false,
                    borderColor: "white",
                    point: {
                        events: {
                            mouseOver: function () {
                                $(
                                    '[data-valuation-summary-legend]:not([data-valuation-summary-legend="' +
                                    this.x +
                                    '"]) > td'
                                ).attr("class", "row-is-muted");
                                $('[data-valuation-summary-legend="' + this.x + '"] > td').attr(
                                    "class",
                                    "row-is-highlighted"
                                );
                            },
                            mouseOut: function () {
                                $("[data-valuation-summary-legend] > td").attr("class", "row-is-highlighted");
                            },
                        },
                    },
                },
            },
            series: [this.getSeriesData(chartData)],
        });
        this.setState({ chart: newChart });
    }

    private getCount = (type: SubAccountType, subType : WrapperSubType = 0) => {
        if (subType === WrapperSubType.JuniorSipp) {            
            this.settings['JuniorSippCount'] = (this.settings['JuniorSippCount'] ?? -1) + 1;
            return  this.settings['JuniorSippCount'] 
        }
        const preCount: number = this.settings?.[type] === undefined ? -1 : this.settings?.[type];
        const curCount = preCount + 1;
        this.settings[type] = curCount;
        return curCount;
    };

    private getColor = (e: ProductValuationDetailSummary) => {
        let color;
        let count;
        let colorCount;
        switch (e.WrapperType) {
            case SubAccountType.Pension:
            case SubAccountType.Sipp:
                count = this.getCount(SubAccountType.Sipp);
                colorCount = count % 3;
                color = `var(--product-sipp-${colorCount + 1})`;
                break;
            case SubAccountType.Npr:
                if (e.WrapperSubType == WrapperSubType.JuniorSipp) {                    
                    count = this.getCount(SubAccountType.Npr,WrapperSubType.JuniorSipp);
                    colorCount = count % 3;
                    color = `var(--product-junior-sipp-${colorCount + 1})`;                   

                } else {
                    count = this.getCount(SubAccountType.Npr);
                    colorCount = count % 3;
                    color = `var(--product-abrdn-sipp-${colorCount + 1})`;                   
                }
                break;
            
            case SubAccountType.StocksIsa:
                count = this.getCount(SubAccountType.StocksIsa);
                colorCount = count % 3;
                color = `var(--product-isa-${colorCount + 1})`;
                break;
            case SubAccountType.InvestmentAccount:
                count = this.getCount(SubAccountType.InvestmentAccount);
                colorCount = count % 3;
                color = `var(--product-pp-${colorCount + 1})`;
                break;
            case SubAccountType.CashAccount:
            case SubAccountType.WrapCash:
                count = this.getCount(SubAccountType.WrapCash);
                colorCount = count % 3;
                color = `var(--product-wrap-cash-${colorCount + 1})`;
                break;
            case SubAccountType.CashIsa:
                count = this.getCount(SubAccountType.CashIsa);
                colorCount = count % 3;
                color = `var(--product-cash-isa-${colorCount + 1})`;
                break;
            case SubAccountType.OffshoreBond:
                count = this.getCount(SubAccountType.OffshoreBond);
                colorCount = count % 3;
                color = `var(--product-offshore-bond-${colorCount + 1})`;
                break;
            case SubAccountType.OnshoreBond:
                count = this.getCount(SubAccountType.OnshoreBond);
                colorCount = count % 3;
                color = `var(--product-onshore-bond-${colorCount + 1})`;
                break;
            case SubAccountType.NotSpecified:
                color = "#000";
                break;
            default:
                color = "#4b4b4b";
        }
        return color;
    };

    private getSeriesData(chartData: Array<ProductValuationDetailSummary>): any {
        const groupsProducts = groupProductDetail(
            PortfolioDashboardMultiSelectionStore.getData(),
            PortfolioDashboardStore.getData(),
            chartData,
            "ClAccountId"
        );
        const _data: ProductValuationDetailSummary[] = groupsProducts.Individual.concat(groupsProducts.Joint).concat(groupsProducts.Trust);
        this.settings = {};
        const series = {
            name: "pieChart",
            colorByPoint: true,
            data: [],
        };

        let sum = 0;

        // has positive and negative values, only display positive values
        if (_data.some((item) => item.TotalValue.Amount > 0) && _data.some((item) => item.TotalValue.Amount < 0)) {
            _data.forEach((product) => {
                if (product.TotalValue.Amount > 0) {
                    sum += product.TotalValue.Amount;
                }
            });
        } else {
            _data.forEach((product) => {
                sum += product.TotalValue.Amount;
            });
        }
        _data.forEach((product, index) => {
            const assetWeight = sum == 0 ? 0 : parseFloat((product.TotalValue.Amount / sum).toFixed(4));
            if (assetWeight > 0) {
                series.data.push(
                    CircleChart.getDataPoint(
                        product.ProductDisplayName,
                        product.ClAccountId,
                        product.Allocation,
                        this.getColor(product),
                        index
                    )
                );
            } else {
                this.getColor(product);
            }
        });
        return series;
    }

    private static getDataPoint(
        dataLabel: string,
        clAccountId: string,
        dataNumber: number,
        color: string,
        index: number
    ): any {
        return {
            name: dataLabel,
            y: dataNumber * 100,
            x: clAccountId,
            color: color,
            index: index,
        };
    }
}
